import { motion } from "framer-motion";
import { Droplets } from "lucide-react";
import { MISSION } from "../../data";
import { Reveal, MaskLineInView } from "./Reveal";

export const Vision = () => (
  <section data-testid="vision-section" className="relative bg-[var(--ink)] text-white overflow-hidden py-16 md:py-36">
    <div className="grain" />
    <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#5b8cff]">
            Our Vision
          </span>
          <h2 className="font-display font-semibold tracking-tighter leading-[1.02] sm:leading-[0.95] mt-5 text-3xl sm:text-5xl md:text-6xl">
            <MaskLineInView>A trusted leader in</MaskLineInView>
            <MaskLineInView delay={0.08}>cap manufacturing.</MaskLineInView>
          </h2>
        </div>
        <Reveal delay={0.15} className="lg:col-span-5">
          <p className="text-lg leading-relaxed text-slate-300 flex gap-4">
            <Droplets className="shrink-0 text-[#5b8cff] mt-1" size={26} />
            Contributing to global access to safe bottled water — the vision that shapes what we
            mold, and how carefully we inspect every single piece.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 md:mt-24">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">
          Our Mission — three commitments, every batch
        </span>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
          {MISSION.map((m, i) => (
            <motion.div
              key={m.t}
              data-testid={`mission-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
              className="bg-[var(--ink-soft)] p-8 md:p-10 hover:bg-[#1a2650] transition-colors duration-400"
            >
              <span className="font-display text-2xl font-semibold text-[#5b8cff]">
                0{i + 1}
              </span>
              <h3 className="font-display text-xl md:text-2xl font-medium mt-5 tracking-tight">
                {m.t}
              </h3>
              <p className="mt-4 text-slate-400 leading-relaxed">{m.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
